import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AppModal = ({ selectedApp }) => {
    const click_url = selectedApp?.redirect_url;
    const payout_vc = selectedApp?.payout_vc.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const [shortURL, setShortURL] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [copyStatus, setCopyStatus] = useState(false);

    useEffect(() => {
        if (click_url) {
            const fetchData = async () => {
                const url = `${site['site_url']}/ajax/tsw.core.php?action=url.short.add`;
                setLoading(true);
                try {
                    const response = await axios({
                        url: url,
                        method: "POST",
                        data: {
                            url: click_url,
                        },
                        withCredentials: false,
                        headers: { 
                            "Content-Type": "multipart/form-data" 
                        },
                    });
                    let responseData = response.data; // console.log(responseData);
                    if (responseData.status === 'success') {
                        setShortURL(responseData.data.shorturl);
                    } else {
                        setError('No data available.');
                    }
                } catch (error) {
                    setError('Failed to load data. Please try again later.');
                } finally {
                    setLoading(false);
                }
            };
            fetchData();
        }
    }, [click_url]);

    const handleShareClick = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: selectedApp?.app_name,
                    text: selectedApp?.app_name,
                    url: click_url
                });
            } catch (error) {
                console.error('Error sharing:', error);
            }
        } else {
            alert('Sharing not supported on this browser. Please copy the URL manually.');
        }
    };


    const handleCopyClick = async () => {
        try {
            await navigator.clipboard.writeText(shortURL);
            setCopyStatus(true);
            setTimeout(() => setCopyStatus(false), 2000); // Reset copy status after 2 seconds
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };

    return (
        <div className="modal fade" id="appModal" tabIndex="-1" aria-labelledby="appModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title text-black" id="appModalLabel">Offer #{selectedApp?.id}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        {selectedApp && (
                          <>    
                            <div className="d-flex mb-3">
                                <div className="flex-shrink-0">
                                    <img className="imaged img-fluid border rounded-md shadow" src={selectedApp.app_icon} alt={selectedApp.app_name} style={{ width: "150px" }} />
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <p className='text-black'>{selectedApp.app_name}</p>
                                    <p className="card-text mb-1">
                                        <small className="text-muted">
                                            {selectedApp.conversions === 0 ? '' : (
                                                <span>{selectedApp.conversions} <i className="bi bi-people" title="Users"></i> earned {selectedApp.conversions * selectedApp.payout_vc} coins.</span>
                                            )}
                                        </small>
                                    </p>
                                    <p className="text-muted mb-2">{selectedApp.description}</p>
                                    <small className="text-muted" dangerouslySetInnerHTML={{ __html: coreTPWall.platformToLabel(selectedApp.platform, selectedApp) }}></small>                                    
                                </div>
                            </div>
                            <div className="alert alert-outline-primary fade show" role="alert">
                                <h4 className="alert-title">Task</h4>
                                <span className="text-muted" dangerouslySetInnerHTML={{ __html: coreTPWall.payoutTypeToAction(selectedApp.payout_type, selectedApp) }}></span>
                            </div>  
                          </>                                
                        )}                      
                    </div>
                    <div className="modal-footer">
                        <div className="row">
                            <div className="col-md-6 text-center">
                                {shortURL && (
                                    <img className="img-fluid img-responsive p-1" src={`${shortURL}?qr`} alt="QR Code" style={{width: '200px'}} />
                                )}
                            </div>
                            <div className="col-md-6">
                                {shortURL && (
                                    <div className="btn-group btn-block mt-1 mb-1">
                                        <button className="btn btn-outline-secondary btn-block" type="button" onClick={handleCopyClick}>
                                            {shortURL}
                                            <i className={`bi ${copyStatus ? 'bi-check-circle' : 'bi-clipboard'} ms-2`}></i>
                                        </button>
                                    </div>
                                )}
                                <a className="btn btn-whatsapp btn-block mt-1 mb-1" href={`https://wa.me/?text=${encodeURIComponent(click_url)}`} target="_blank">
                                    <i className="bi bi-whatsapp"></i>
                                    Share via WhatsApp
                                </a>
                                <button className="btn btn-outline-primary btn-block mt-1 mb-1" type="button" onClick={handleShareClick}>
                                    <i className="bi bi-share"></i>
                                    Share via Apps
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="btn-group btn-block" role="group">
                            <a className="btn btn-warning btn-block" href={click_url} target="_blank" style={{ width: "100%" }}>
                                <i className="fas fa-coins fa-fw"></i> <i className="bi bi-plus m-0"></i> {payout_vc} 
                                <span className="Xd-noneX Xd-sm-blockX">&nbsp;COIN(s)</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AppModal;
